var t = /* @__PURE__ */ ((l) => (l.VERTICAL = "vertical", l.SPLIT = "split", l.HORIZONTAL = "horizontal", l))(t || {});
export {
  t as l
};
